import '../CsvJsonInfoPages.scss';


function CategoryDescriptions() {

    const data = [
        { field: 1, description: 'Category Code (Int)' },
        { field: 2, description: 'Category Description (Char)' },
        { field: 3, description: 'Category Type (Char)' },
        { field: 4, description: 'Colour/Trim/Hood Type (Char)' },
        { field: 5, description: 'Generic Ascii Type (For Option categories only) (Char)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Category Descriptions</h1>
            <p>This file contains the category descriptions for the Options, Generic, and Technical Data description files.  <br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDDictionaryCategory.txt .txt<br />
                LIGHTS_yyyy-mm-dd_NVDDictionaryCategory.txt .txt<br />
                HEAVIES_yyyy-mm-dd_NVDDictionaryCategory.txt .txt<br />
                BIKES_yyyy-mm-dd_NVDDictionaryCategory.txt .txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p>
                Note: The Category type can contain the following:<br/>
                O   - Option Category<br/>
                T   - Technical Category<br/>
                G   - Generic Category<br/><br/>

                The Colour/Trim/Hood type can contain the following:<br/>
                C   - Colour<br/>
                T   - Trim<br/>
                H   - Hood<br/>
                U   - Uncategorised
            </p>
        </div>
    );
}

export default CategoryDescriptions;
